<template>
    <v-content v-if="! isLogged">
        <v-container fluid grid-list>
            <v-layout row align-center justify-center mt-4>
                <v-flex xs3 sm3 md3>
                  <img :src="BASE_ASSETS + logo" style="height: 100%">
                </v-flex>
            </v-layout>
            <v-layout row align-center justify-center mt-3>
                <v-flex xs12 sm12 md12>
                    <p class="display-1 text-xs-center">Enter Email to reset password</p>
                </v-flex>
            </v-layout>

            <v-layout row align-center justify-center mt-3>
                <v-flex xs12 sm6 md5>
                    <form @submit.prevent="update">
                        <v-text-field
                                type="email"
                                v-validate="'required'"
                                v-model="data.email"
                                :error-messages="errors.collect('data.email')"
                                label="Email"
                                data-vv-name="data.email"
                        ></v-text-field>
                        <v-btn block color="secondary" class="text--primary" type="submit">Send password reset link</v-btn>
                    </form>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>

    import { BASE_ASSETS } from  '../../../config';

    export default {
        props: ['token'],
        $_veeValidate: {
            validator: 'new'
        },
        data : function() {
            return {
                data : {},
                BASE_ASSETS: BASE_ASSETS
            }
        },
        created () {
            this.data.token = this.token;
        },
        computed : {
            isLogged : function(){
                return this.$store.getters.isLogged;
            }
        },
        mounted () {
            this.$validator.localize('en', this.dictionary)
        },
        methods : {
            update : function() {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.$store.dispatch('sendResetPassword', this.data).then((res) => {
                            this.$router.push({ name: 'login' });
                        }).catch((error) => {
                        });
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/reset_password/SendResetPasswordComponent.vue